export const LANGUAGE_DELETE_RESET = 'LANGUAGE_DELETE_RESET'
export const LANGUAGE_DELETE_SET_ERROR = 'LANGUAGE_DELETE_SET_ERROR'
export const LANGUAGE_DELETE_SET_DELETED = 'LANGUAGE_DELETE_SET_DELETED'
export const LANGUAGE_DELETE_TOGGLE_LOADING = 'LANGUAGE_DELETE_TOGGLE_LOADING'
